import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * La vista a la que llega el administrador al entrar. Misma razón que en las otras dos:
 * `_direccion` no tiene `path`.
 *
 * La pantalla de usuarios que crea la tarea 19 cuelga del mismo grupo en `/usuarios`, y
 * es hermana de esta.
 */
export const rutaInicioDireccion = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/direccion',
  component: lazyRouteComponent(() => import('./pantalla-inicio.js'), 'InicioDireccion'),
});
